export enum ReportTypes {
  OEE = 'OEE',
  Downtime = 'Downtime',
  Product = 'Product',
  Shift_History = 'Shift_History' // eslint-disable-line  @typescript-eslint/camelcase
}
